function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.941 14.78a.86.86 0 01.059.314v5.18c0 .477-.39.864-.87.864a.867.867 0 01-.87-.864V17.09l-2.55 2.38a8.735 8.735 0 01-8.069 2.318 8.676 8.676 0 01-6.278-5.543.862.862 0 01.53-1.102.871.871 0 011.11.526 6.94 6.94 0 005.022 4.434 7 7 0 006.475-1.874l2.435-2.272h-3.022a.867.867 0 01-.87-.864c0-.477.39-.864.87-.864h5.217a.87.87 0 01.807.54l.004.011zM2.06 10.22A.86.86 0 012 9.907v-5.18c0-.477.39-.864.87-.864s.87.387.87.864V7.91l2.55-2.38a8.735 8.735 0 018.069-2.318 8.676 8.676 0 016.278 5.543.862.862 0 01-.53 1.102.871.871 0 01-1.11-.526 6.94 6.94 0 00-5.022-4.434A7 7 0 007.5 6.772L5.065 9.044h3.022c.48 0 .87.387.87.864s-.39.864-.87.864H2.87a.87.87 0 01-.807-.54l-.003-.012z"
});

var SvgRefresh = function SvgRefresh(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/refresh.b624c31a.svg";
export { SvgRefresh as ReactComponent };